// utils/logout.js
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('emp_list_items_per_page');
  localStorage.removeItem('emp_list_status_filter');
  localStorage.removeItem('emp_list_current_page');
  localStorage.removeItem('emp_list_sort_config');
  localStorage.removeItem('emp_list_search_term');

  // Clear cookies (optional)
  document.cookie = "post_login_verify_payload=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  document.cookie = "post_login_quick_summary_path=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

  // Clear dashboard undo history — must not carry over to next login session
  sessionStorage.removeItem('server_monitoring_undo_v1');

  // Signal dashboard components to clear undo history before page redirects
  window.dispatchEvent(new CustomEvent('app:logout'));

   // Redirect to login
  const params = new URLSearchParams(window.location.search);
  if (!params.has('room')) {
    window.location.href = '/';
  } else {
    window.location.reload();
  }
};
